export default "__VITE_ASSET__CLsMsmjl__"